<!--导航栏-->
<template>
  <div>
    <el-upload
      class="upload-demo"
      ref="upload"
      :action="upload.action"
      :auto-upload="false"
      :limit="1"
      :on-success="uploadCompete"
      :file-list="fileList"
      :on-change="onChange"
    >
      <el-button
        v-if="isUpLoadBtn === '1'"
        slot="trigger"
        size="small"
        type="primary"
        >选取文件（excel）</el-button
      >
      <el-button
        v-if="isUpLoadBtn === '1'"
        style="margin-left: 10px"
        size="small"
        type="success"
        @click="uploadSubmit"
      >
        上传至服务器
      </el-button>
      <el-button
        v-if="isDownBtn === '1'"
        style="margin-left: 10px"
        size="small"
        type="warning"
        @click="downSubmitHandler"
        >{{ mbBtnTxt }}</el-button
      >
    </el-upload>

    <!-- 模版下载 form表单 开始 -->
    <form :action="down.action" ref="form" target="_blank" method="post">
      <input type="text" name="op" v-model="op" style="display:none" />
      <input
        type="text"
        name="objData"
        v-model="objData"
        style="display:none"
      />
    </form>
    <!-- 模版下载 form表单 开始 -->
  </div>
</template>

<script>
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "UploadCurrCom",
  components: { allParam },
  props: {
    mainLoadData: {
      //父控件中的加载数据方法
      type: Function,
      default: null
    },
    op: {
      //op参数
      type: String,
      default: ""
    },
    methodName: {
      //方法名
      type: String,
      default: ""
    },
    paramData: {
      type: Object,
      default: null
    },
    tableColumns: {
      type: Array,
      default: null
    },
    mbBtnTxt: {
      type: String,
      default: "模版下载"
    },
    isUpLoadBtn: {
      type: String,
      default: "1"
    },
    isDownBtn: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      down: {
        action: allParam.downMbUrl
      },
      upload: {
        action: allParam.uploadUrl + "?op=" + this.op + "&ssid=" + this.ssid
      },
      fileList: [],
      loading: "",
      objData: ""
    };
  },

  mounted() {},
  methods: {
    onChange(file, fileList) {
      this.fileList = fileList; //把当前文件赋值给 fileList
    },
    //上传按钮
    uploadSubmit() {
      this.upload.action =
        allParam.uploadUrl + "?op=" + this.op + "&ddh=" + this.paramData.DDH;
      if (this.fileList.length === 0) {
        alert("请选择上传文件");
        return;
      }
      this.$confirm("是否提交服务端？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = this.$loading({
            lock: true, //lock的修改符--默认是false
            text: "Loading", //显示在加载图标下方的加载文案
            spinner: "el-icon-loading", //自定义加载图标类名
            background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
            target: document.querySelector("#table") //loadin覆盖的dom元素节点
          });
          this.$refs.upload.submit();
        })
        .catch(() => {});
    },
    //上传完成
    uploadCompete(res, file) {
      this.loading.close();
      this.$refs.upload.clearFiles();
      this.$alert(res.msg, "导入结果", {
        dangerouslyUseHTMLString: true
      });
      this.mainLoadData();
    },
    //下载excel模版
    downSubmitHandler() {
      var tempAttr = {
        tableColumns: this.tableColumns,
        search: this.paramData
      };
      this.objData = JSON.stringify(tempAttr);
      this.$nextTick(() => {
        this.$refs.form.submit();
      });
    }
  }
};
</script>
<style>
.el-message-box {
  max-height: 850px !important;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadCurrCom/UploadCurrCom.vue